

















































import Vue from 'vue';
import StoreAlert from '@/components/StoreAlert.vue';
import {History, SortOption, TableData, TableOptions} from '@/types';

function defaultOptions(): TableOptions {
  return {
    sortBy: ['id'],
    sortDesc: [true],
    page: 1,
    itemsPerPage: 20
  };
}

export default Vue.extend({
  name: 'Contracts',
  components: { StoreAlert },
  data(): TableData<History> {
    return {
      headers: [
        { value: 'id', text: 'ID' },
        { value: 'by_user', text: 'By User' },
        { value: 'command', text: 'Command' },
        { value: 'created_at', text: 'Created at' },
        { value: 'updated_at', text: 'Updated at' }
      ],
      items: [],
      options: defaultOptions(),
      total: 0,
      expanded: []
    };
  },
  watch: {
    $hash() {
      this.$store.updateTableOptions(this.options, defaultOptions());
      this.load();
    }
  },
  computed: {
    hasFilter(): boolean {
      return Object.keys(this.$store.query).length > 0;
    },
    isCard(): boolean {
      return this.hasFilter && this.items.length === 1;
    },
    sort(): SortOption[] {
      const { sortBy, sortDesc } = this.options;
      return (sortBy as string[]).map((column, i) => {
        return {
          column,
          order: sortDesc[i] ? 'desc' : 'asc'
        };
      });
    }
  },
  methods: {
    updateOptions(options: TableOptions) {
      this.$store.setTableOptions(options, defaultOptions());
    },
    itemClass() {
      return '';
    },
    load() {
      this.cleanError();
      this.startLoading();
      const { page, itemsPerPage } = this.options;
      return this.$store.api.history({
        where: this.$store.query,
        sort: this.sort,
        page,
        perPage: itemsPerPage
      }).then(({ items, total }) => {
        this.stopLoading();
        this.items = items;
        this.total = total;
      }).catch(this.setError);
    }
  },
  created() {
    this.$store.updateTableOptions(this.options, defaultOptions());
    this.load();
  }
});
